import React from "react";
import { Formik, ErrorMessage } from "formik";
import ImageUploader from "../components/ImageUploader";
import {
	add,
	wardQuestion,
	photo,
	name,
	area,
	areaType,
	landField,
	rotInfo,
	unit,
	areaList,
	ward,
	selectedLanguage,
} from "../data/institute";
import FormFooterButtons from "../components/FormFooterButtons";
import { GetUUID } from "../data/helpers/RandomNumGenerator";
import { Card } from "react-bootstrap";

const initData = {
	ward: "",
	name: "",
	landField: "",
	areaType: "",
	area: "",
	rotInfo: "",
	uniqueIdentifier: GetUUID(),
};

const Waste = (props) => (
	<div>
		<Formik
			enableReinitialize
			initialValues={props.data ? props.data : initData}
			validate={(values) => {
				const errors = {};
				if (!values.ward) {
					errors.ward = "Required";
				}
				// if (!values.riskArea) {
				//     errors.riskArea = 'Required';
				// }
				// if (!values.address) {
				//     errors.address = 'Required';
				// }
				// if (!values.effectFromDisasters) {
				//     errors.effectFromDisasters = 'Required';
				// }
				// else
				// if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
				// 	errors.email = "Invalid email address";
				// }
				return errors;
			}}
			onSubmit={(values, { setSubmitting }) => {
				console.log(values);
				setTimeout(() => {
					props.submit(values);
					setSubmitting(false);
				}, 400);
			}}
		>
			{({
				values,
				touched,
				errors,
				dirty,
				isSubmitting,
				handleChange,
				handleBlur,
				handleSubmit,
				handleReset,
			}) => (
				<>
					<form className="form survey-form" onSubmit={handleSubmit}>
						<Card>
							<Card.Body>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{wardQuestion[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="ward"
											name="ward"
											onChange={handleChange}
											value={values.ward ? values.ward : "selectOne"}
										>
											<option value="selectOne" disabled>
												कुनै एक छान्नुहोस्
											</option>
											{ward.map((woda) => (
												<option value={woda.value}>
													{woda[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="ward"
											component="div"
										/>
									</div>
									<div className="col-md-6">
										<label className="form-control-label">
											{name[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={name[selectedLanguage]}
											name="name"
											onChange={handleChange}
											value={values.name}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="name"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{area[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={area[selectedLanguage]}
											name="area"
											onChange={handleChange}
											value={values.area}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="area"
											component="div"
										/>
									</div>
									{/* <div className="col-md-3">
										<label className="form-control-label">
											{unit[selectedLanguage]}
										</label>
										<select
											className="form-control"
											id="areaType"
											name="areaType"
											onChange={handleChange}
											value={values?.areaType}
										>
											{areaList.map((alist) => (
												<option value={alist.value}>
													{alist[selectedLanguage]}
												</option>
											))}
										</select>
										<ErrorMessage
											className="invalid-feedback"
											name="areaType"
											component="div"
										/>
									</div> */}

									<div className="col-md-6">
										<label className="form-control-label">
											{rotInfo[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={rotInfo[selectedLanguage]}
											name="rotInfo"
											onChange={handleChange}
											value={values.rotInfo}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="rotInfo"
											component="div"
										/>
									</div>
								</div>
								<div className="form-group row">
									<div className="col-md-6">
										<label className="form-control-label">
											{landField[selectedLanguage]}
										</label>
										<input
											type="text"
											className="form-control"
											placeholder={landField[selectedLanguage]}
											name="landField"
											onChange={handleChange}
											value={values.landField}
										/>
										<ErrorMessage
											className="invalid-feedback"
											name="landField"
											component="div"
										/>
									</div>

									<div className="col-md-6">
										<label>{photo[selectedLanguage]}</label>
										<ImageUploader fileListContent={props.fileListContent} />
									</div>
								</div>

								<div className="card-footer text-right">
									<FormFooterButtons />
								</div>
							</Card.Body>
						</Card>
					</form>
				</>
			)}
		</Formik>
	</div>
);

export default Waste;
